module.exports = __webpack_public_path__ + "a2569550d354d5e3ecbca05b8bd9fbc3.svg";